export const isEmpty = (obj: Record<string, any>) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

/**
 * Check if the given string is a positive integer.
 */
export function isPositiveInteger(s: string | null): boolean {
  if (s === null) {
    return false;
  }
  const parsed = parseInt(s);
  return /^\d+$/.test(s) && String(parseInt(s)) === s && parsed > 0;
}

/**
 * Return the given string as an integer if it is a positive integer, otherwise null.
 */
export function asPositiveInteger(s: string | null) {
  if (isPositiveInteger(s)) {
    return parseInt(s as string);
  }
  return null;
}
